export default function Version() {
    return (
        <>
            <small>v1.155</small>
        </>
    )
}